import { EventEmitter } from '@angular/core';
var TrackCapsDirective = /** @class */ (function () {
    function TrackCapsDirective() {
        this.capsLock = new EventEmitter();
    }
    TrackCapsDirective.prototype.onKeyDown = function (event) {
        var capsOn = event.getModifierState && event.getModifierState('CapsLock');
        this.capsLock.emit(capsOn);
    };
    TrackCapsDirective.prototype.onKeyUp = function (event) {
        var capsOn = event.getModifierState && event.getModifierState('CapsLock');
        this.capsLock.emit(capsOn);
    };
    return TrackCapsDirective;
}());
export { TrackCapsDirective };
